import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO, ESTATUS_CANCELADO } from 'utils/constants';

import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/catalogos/modificacion-de-jornada-modificacion';

/**
 * GET
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getJornadasModificacionDetalle = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getJornadaModificacionDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postJornadaModificacionDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchJornadaModificacionDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 *
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const getJornadaModificacionTotalesDetalle = async (id, values) => {
  try {
    const response = await API.get(`/nominas/descuentos-carga-externa-archivo-totales-vista-optimized/${id}/`, values);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 *
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteJornadaModificacionDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const autorizarExternaDescuentoDetalle = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const CancelarExternaDescuentoDetalle = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_CANCELADO });
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT - Agrega registros a un descuento externo ya creado
 * @param {number} id - ID del descuento externo
 * @param {object[]} registros - Arreglo de registros
 * @returns {Promise<{}>}
 */
export const putExternaDescuentoDetalle = async (id, registros) => {
  try {
    const response = await API.put(`/nominas/agregar-descuentos-carga-externa-archivo/${id}/`, registros);
    onSuccess(response, 'Enviado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
